/* Conteo de entrada: anima las cifras configuradas, sin inventar crecimiento
   ni consultar redes sociales. El valor final también existe sin JavaScript. */
(function () {
  'use strict';
  if (window.__miSocialCounters) return;
  window.__miSocialCounters = true;
  var montadas = new WeakSet();
  var movimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  function montar(grupo) {
    if (montadas.has(grupo)) return;
    montadas.add(grupo);
    var contadores = Array.prototype.map.call(grupo.querySelectorAll('[data-mi-countup]'), function (nodo) {
      var final = nodo.getAttribute('data-mi-countup').trim();
      var partes = final.match(/^(\d+(?:[.,]\d+)?)\s*([mk])?(\+)?$/i);
      if (!partes) return null;
      var unidad = partes[2] || '';
      var cantidad = unidad ? Number(partes[1].replace(',', '.')) : Number(partes[1].replace(/[.,]/g, ''));
      if (!Number.isFinite(cantidad) || cantidad <= 0) return null;
      var decimales = unidad && /[.,]/.test(partes[1]) ? partes[1].split(/[.,]/)[1].length : 0;
      return { nodo: nodo, final: final, cantidad: cantidad, unidad: unidad, decimales: decimales, sufijo: partes[3] || '', coma: partes[1].includes(',') };
    }).filter(Boolean);
    if (!contadores.length) return;
    var frame = null;
    var observador = null;
    var iniciado = false;

    function terminar() {
      window.cancelAnimationFrame(frame);
      if (observador) observador.disconnect();
      contadores.forEach(function (contador) {
        contador.nodo.textContent = contador.final;
        contador.nodo.setAttribute('data-mi-counter-state', 'done');
      });
      movimiento.removeEventListener('change', cambiarMovimiento);
    }
    function cambiarMovimiento() {
      if (movimiento.matches) terminar();
    }
    function animar() {
      if (iniciado) return;
      iniciado = true;
      if (observador) observador.disconnect();
      if (movimiento.matches) { terminar(); return; }
      var inicio = null;
      contadores.forEach(function (contador) { contador.nodo.setAttribute('data-mi-counter-state', 'running'); });
      function paso(ahora) {
        if (!grupo.isConnected) { terminar(); return; }
        if (inicio === null) inicio = ahora;
        var progreso = Math.min(1, (ahora - inicio) / 1700);
        var avance = 1 - Math.pow(1 - progreso, 3);
        contadores.forEach(function (contador) {
          var numero = contador.cantidad * avance;
          var texto = contador.unidad ? numero.toFixed(contador.decimales) : Math.floor(numero).toLocaleString('es-CO');
          if (contador.unidad && contador.coma) texto = texto.replace('.', ',');
          contador.nodo.textContent = texto + contador.unidad + contador.sufijo;
        });
        if (progreso < 1) frame = window.requestAnimationFrame(paso);
        else terminar();
      }
      frame = window.requestAnimationFrame(paso);
    }
    movimiento.addEventListener('change', cambiarMovimiento);
    if (movimiento.matches || !window.IntersectionObserver) { terminar(); return; }
    contadores.forEach(function (contador) { contador.nodo.setAttribute('data-mi-counter-state', 'ready'); });
    observador = new IntersectionObserver(function (entradas) {
      if (entradas.some(function (entrada) { return entrada.isIntersecting; })) animar();
    }, { threshold: .35 });
    observador.observe(grupo);
    /* El editor puede retirar una sección que aún no entró en pantalla. */
    document.addEventListener('shopify:section:unload', function retirar(evento) {
      if (!evento.target.contains(grupo)) return;
      terminar();
      document.removeEventListener('shopify:section:unload', retirar);
    });
  }
  function montarTodas(raiz) {
    if (raiz.nodeType === 1 && raiz.matches('.mi-sp__metricas')) montar(raiz);
    raiz.querySelectorAll('.mi-sp__metricas').forEach(montar);
  }
  function iniciar() {
    montarTodas(document);
    new MutationObserver(function (cambios) {
      cambios.forEach(function (cambio) {
        cambio.addedNodes.forEach(function (nodo) {
          if (nodo.nodeType === 1) montarTodas(nodo);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
